import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { JokerButton, ButtonType } from "material-ui-jokerpro";
import styles from "./ResendButton.module.css";

type ResendButtonProps = {
  resendTime?: number;
  onClick?: (e: any) => void;
};

export const ResendButton: React.FC<ResendButtonProps> = ({
  resendTime = 45,
  onClick,
}) => {
  const { t } = useTranslation();

  const [isResending, setIsResending] = useState(false);
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    if (!isResending) {
      return;
    }
    if (countdown > 0) {
      const intervalId = setInterval(() => {
        setCountdown(countdown - 1);
      }, 1000);

      return () => clearInterval(intervalId);
    } else {
      setIsResending(false);
    }
  }, [isResending, countdown]);

  const handleResend = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setIsResending(true);
    setCountdown(resendTime);
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <div>
      {isResending ? (
        <span className={styles["resend-text"]}>
          Resend code in{" "}
          <span className={styles["count-down"]}>{countdown}</span>s
        </span>
      ) : (
        <JokerButton
          text={t("resend_button.button_title")}
          type={ButtonType.Link}
          onClick={handleResend}
          highlighted
          underlined
        />
      )}
    </div>
  );
};
